webpackJsonp([3],{

/***/ "./node_modules/@justgiving/dna-form/lib/character-count/character-count.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var privateData = {
	createCounter: function createCounter() {
		var count = document.createElement('span');
		var countText = document.createTextNode(this.maxLength);
		count.classList.add('dna-character-count');
		count.appendChild(countText);
		return count;
	}
};

/**
 * Class representing a dna character count
 * @classdesc Constructor for a dna character count
 * @param {Object} options.el. Class instance's parent element
 */

var CharacterCount = function () {
	function CharacterCount() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, CharacterCount);

		this.el = options.el;
		this.maxLength = options.maxLength;
		this.trimInput = options.trimInput;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM() || !this.maxLength) {
			return _eventemitter.emitter.emit('dna.CharacterCount.didCancelInit', {
				emitter: this
			});
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.CharacterCount.didInit', {
			emitter: this
		});
	}

	/**
  * Verify the required DOM nodes are present
  * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  * @returns {Boolean} Whether all DOM nodes are present or not
  */

	_createClass(CharacterCount, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el) {
				hasVerified = false;
			}
			return hasVerified;
		}

		/**
   * Initialise the class
   * @description
   */

	}, {
		key: 'init',
		value: function init() {
			if (/dna-[a-z0-9\-]*wrap/i.test(this.el.parentNode.className)) {
				if (!this.el.parentNode.classList.contains('dna-character-count-wrap')) {
					this.augmentWrapper();
				} else {
					this.count = this.el.parentNode.querySelector('.dna-character-count');
				}
			} else {
				this.wrapEl();
			}

			if (this.trimInput) {
				this.el.setAttribute('maxlength', this.maxLength);
			}

			var keyupHandler = function () {
				var newLines = (this.el.value.replace(/\r\n/g, '\n').match(/\n/g) || '').length;
				var count = this.maxLength - newLines - this.el.value.length;
				this.count.textContent = count;
				if (count <= 0) {
					this.count.classList.add('dna-character-count-full');
				} else {
					this.count.classList.remove('dna-character-count-full');
				}
			}.bind(this);

			var clickHandler = function (e) {
				e.preventDefault();
				this.el.focus();
			}.bind(this);

			var mouseEnterHandler = function (e) {
				e.preventDefault();
				this.el.parentNode.classList.add('dna-character-count-wrap-hover');
			}.bind(this);

			var mouseLeaveHandler = function (e) {
				e.preventDefault();
				this.el.parentNode.classList.remove('dna-character-count-wrap-hover');
			}.bind(this);

			privateData.keyupHandler = keyupHandler;
			privateData.clickHandler = clickHandler;
			privateData.mouseEnterHandler = mouseEnterHandler;
			privateData.mouseLeaveHandler = mouseLeaveHandler;

			keyupHandler();
			this.bindEvents();
		}

		/**
   * Wrap this.el in div and add span
   */

	}, {
		key: 'wrapEl',
		value: function wrapEl() {
			var div = document.createElement('div');
			var count = privateData.createCounter.call(this);
			div.classList.add('dna-character-count-wrap');
			if (this.el.type === 'textarea') {
				div.classList.add('dna-character-count-wrap-textarea');
			}
			this.el.parentNode.insertBefore(div, this.el);
			div.appendChild(this.el);
			div.appendChild(count);
			this.count = count;
		}

		/**
   * Add wrapper class to existing wrapper
   * and append counter span
   */

	}, {
		key: 'augmentWrapper',
		value: function augmentWrapper() {
			var parent = this.el.parentNode;
			var count = privateData.createCounter.call(this);
			parent.classList.add('dna-character-count-wrap');
			if (this.el.type === 'textarea') {
				parent.classList.add('dna-character-count-wrap-textarea');
			}
			parent.appendChild(count);
			this.count = count;
		}

		/**
   * Bind DOM events
   */

	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			var keyupHandler = privateData.keyupHandler;
			var clickHandler = privateData.clickHandler;
			var mouseEnterHandler = privateData.mouseEnterHandler;
			var mouseLeaveHandler = privateData.mouseLeaveHandler;
			this.el.addEventListener('keyup', keyupHandler, false);
			this.count.addEventListener('click', clickHandler, false);
			this.count.addEventListener('mouseenter', mouseEnterHandler, true);
			this.count.addEventListener('mouseleave', mouseLeaveHandler, true);
		}

		/**
   * Unbind DOM events
   */

	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			var keyupHandler = privateData.keyupHandler;
			var clickHandler = privateData.clickHandler;
			var mouseEnterHandler = privateData.mouseEnterHandler;
			var mouseLeaveHandler = privateData.mouseLeaveHandler;
			this.el.removeEventListener('keyup', keyupHandler, false);
			this.count.removeEventListener('click', clickHandler, false);
			this.count.removeEventListener('mouseenter', mouseEnterHandler, true);
			this.count.removeEventListener('mouseleave', mouseLeaveHandler, true);
		}
	}]);

	return CharacterCount;
}();

exports.default = CharacterCount;

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.InputSelectGroup = exports.InputPrefix = exports.Input = exports.CharacterCount = undefined;

var _characterCount = __webpack_require__("./node_modules/@justgiving/dna-form/lib/character-count/character-count.js");

var _characterCount2 = _interopRequireDefault(_characterCount);

var _input = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input/input.js");

var _input2 = _interopRequireDefault(_input);

var _inputPrefix = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input-prefix/input-prefix.js");

var _inputPrefix2 = _interopRequireDefault(_inputPrefix);

var _inputSelectGroup = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input-select-group/input-select-group.js");

var _inputSelectGroup2 = _interopRequireDefault(_inputSelectGroup);

var _select = __webpack_require__("./node_modules/@justgiving/dna-form/lib/select/select.js");

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CharacterCount = _characterCount2.default;
exports.Input = _input2.default;
exports.InputPrefix = _inputPrefix2.default;
exports.InputSelectGroup = _inputSelectGroup2.default;
exports.Select = _select2.default;

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/input-prefix/input-prefix.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class representing a dna input-prefix
 * @classdesc Constructor for a dna input-prefix
 * @param {Object} options.el. Class instance's parent element
 */

var InputPrefix = function () {
	function InputPrefix() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, InputPrefix);

		this.el = options.el;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM()) {
			_eventemitter.emitter.emit('dna.InputPrefix.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.InputPrefix.didInit', {
			emitter: this
		});

		return this;
	}
	/**
  * Verify the required DOM nodes are present
  * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  * @returns {Boolean} Whether all DOM nodes are present or not
  */

	_createClass(InputPrefix, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el || !this.el.hasAttribute('data-dna-input-prefix')) {
				hasVerified = false;
			}
			return hasVerified;
		}
		/**
   * Initialise the class
   * @description
   */

	}, {
		key: 'init',
		value: function init() {
			this.inputPadding = parseInt(getComputedStyle(this.el).paddingLeft, 10);
			this.wrapInput();
			this.createTokenEl();
			this.appendToken();
			this.setPrefix();
		}
		/**
   * Create wrapper around input
   */

	}, {
		key: 'wrapInput',
		value: function wrapInput() {
			if (!this.el.parentNode.classList.contains('dna-input-prefix')) {
				this.wrapper = document.createElement('span');
				this.wrapper.classList.add('dna-input-prefix');
				this.el.parentNode.insertBefore(this.wrapper, this.el);
				this.wrapper.appendChild(this.el);
			}
		}
		/**
   * Create element to hold prefix
   */

	}, {
		key: 'createTokenEl',
		value: function createTokenEl() {
			this.token = document.createElement('span');
			this.token.classList.add('dna-input-prefix-token');
		}
		/**
   * Append the prefix token to the input wrapper
   */

	}, {
		key: 'appendToken',
		value: function appendToken() {
			this.wrapper.appendChild(this.token);
		}
	}, {
		key: 'setPrefix',
		value: function setPrefix() {
			this.setTokenLabel();
			this.getPrefixWidth();
			this.setInputPadding();
		}
		/**
   * Set the text (label) of the prefix token to the data-dna-input-prefix value
   */

	}, {
		key: 'setTokenLabel',
		value: function setTokenLabel() {
			this.token.innerHTML = this.el.dataset.dnaInputPrefix;
		}
		/**
   * Get the computed width of the label
   */

	}, {
		key: 'getPrefixWidth',
		value: function getPrefixWidth() {
			return this.token.offsetWidth;
		}
		/**
   * Set padding on the input to account for prefix width plus its own padding
   */

	}, {
		key: 'setInputPadding',
		value: function setInputPadding() {
			this.el.style.paddingLeft = this.inputPadding + this.getPrefixWidth() + 'px';
		}
		/**
   * Reset the prefix label to latest data-dna-input-prefix value
   */

	}, {
		key: 'updatePrefix',
		value: function updatePrefix() {
			this.setTokenLabel();
			this.setInputPadding();
		}
	}]);

	return InputPrefix;
}();

exports.default = InputPrefix;

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/input-select-group/input-select-group.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

var _select = __webpack_require__("./node_modules/@justgiving/dna-form/lib/select/select.js");

var _select2 = _interopRequireDefault(_select);

var _inputPrefix = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input-prefix/input-prefix.js");

var _inputPrefix2 = _interopRequireDefault(_inputPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var clickHandler = Symbol();
var prefixChangeHandler = Symbol();
var inputChangeHandler = Symbol();

/**
 * Class representing a dna select
 * @classdesc Constructor for a dna select
 * @param {object} options.el. Class instance's parent element
 * @param {number} options.selectWidth. Constrain element to given width, otherwise set to largest option
 * @param {string} options.selectPosition. Give 'left' or 'right' for options list to clamp to
 * @param {bool} options.valueAsSelected. If true, have selectedValue be equal to value, not option text
 */

var InputSelectGroup = function () {
	function InputSelectGroup() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, InputSelectGroup);

		this.el = options.el;
		this.input = this.el.querySelector('.dna-input');
		this.select = this.el.querySelector('.js-dna-select');
		this.selectWidth = options.selectWidth || 0;
		this.selectOptionsWidth = options.selectOptionsWidth || 0;
		this.selectOptionsPosition = options.selectOptionsPosition || 'right';
		this.selectValueAsSelected = options.selectValueAsSelected || false;
		this.bindSelectValueToInput = options.bindSelectValueToInput || false;
		this.bindSelectValueToPrefix = options.bindSelectValueToPrefix || false;
		this.bindingTransform = options.bindingTransform ? options.bindingTransform : function (input) {
			return input;
		};

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM() || document.querySelector('html').className.indexOf('ie8') > -1) {
			_eventemitter.emitter.emit('dna.InputSelectGroup.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.InputSelectGroup.didInit', {
			emitter: this
		});

		return this;
	}

	/**
  * Verify the required DOM nodes are present
  * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  * @returns {Boolean} Whether all DOM nodes are present or not
  */

	_createClass(InputSelectGroup, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el || !this.el.classList.contains('dna-input-select-group') || !this.input || !this.select) {
				hasVerified = false;
			}
			return hasVerified;
		}

		/**
   * Initialise the class
   * @description
   */

	}, {
		key: 'init',
		value: function init() {
			var _this = this;

			this.initComponents();

			this[clickHandler] = function (e) {
				if (e.target.closest('.dna-input-select-group') !== null && e.target.closest('.dna-input-select-group') === _this.el) {
					_this.el.classList.add('is-active');
				} else {
					_this.el.classList.remove('is-active');
				}
			};
			this[inputChangeHandler] = function (e) {
				if (e.target === _this.select) {
					_this.input.value = e.target.value;
				}
				if (e.target === _this.input) {
					[].slice.apply(_this.select.options).forEach(function (option, index) {
						if (option.value === e.target.value) {
							_this.dnaSelect.chooseOption(_this.dnaSelect.list.children[index]);
						}
					});
				}
			};
			this[prefixChangeHandler] = function (e) {
				if (e.target === _this.select) {
					_this.input.setAttribute('data-dna-input-prefix', _this.bindingTransform(e.target.value));
					_this.dnaInputPrefix.updatePrefix();
				}
			};

			this.bindEvents();
		}
	}, {
		key: 'initComponents',
		value: function initComponents() {
			var el = this.select;
			var width = this.selectWidth;
			var optionsWidth = this.selectOptionsWidth;
			var optionsPosition = this.selectOptionsPosition;
			var valueAsSelected = this.selectValueAsSelected;

			this.dnaSelect = new _select2.default({ el: el, width: width, optionsWidth: optionsWidth, optionsPosition: optionsPosition, valueAsSelected: valueAsSelected });

			if (this.input.classList.contains('js-dna-input-prefix')) {
				this.dnaInputPrefix = new _inputPrefix2.default({ el: this.input });
			}
		}
	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			document.addEventListener('click', this[clickHandler], false);

			if (this.bindSelectValueToInput) {
				this.input.value = this.select.value;
				document.addEventListener('change', this[inputChangeHandler], false);
			}

			if (this.bindSelectValueToPrefix && this.dnaInputPrefix) {
				this.input.setAttribute('data-dna-input-prefix', this.bindingTransform(this.select.value));
				this.dnaInputPrefix.updatePrefix();
				document.addEventListener('change', this[prefixChangeHandler], false);
			}
		}
	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			document.removeEventListener('click', this[clickHandler], false);

			if (this.bindSelectValueToInput) {
				document.removeEventListener('change', this[inputChangeHandler], false);
			}

			if (this.bindSelectValueToPrefix && this.dnaInputPrefix) {
				document.removeEventListener('change', this[prefixChangeHandler], false);
			}
		}
	}]);

	return InputSelectGroup;
}();

module.exports = InputSelectGroup;

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/input/creditcard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CreditCard = undefined;

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var handler = Symbol();
var addValidClasses = Symbol();
var addValidPendingClasses = Symbol();
var addErrorClasses = Symbol();
var removeClasses = Symbol();

var CreditCard = exports.CreditCard = function () {
	function CreditCard() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, CreditCard);

		this.el = options.el;
		this.regex = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$/; // Visa or MasterCard
		this.validCards = ['visa', 'visa-electron', 'delta', 'mastercard', 'maestro'];

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM()) {
			_eventemitter.emitter.emit('dna.Input.CreditCard.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.Input.CreditCard.didInit', {
			emitter: this
		});
	}

	/**
  * Verify the required DOM nodes are present
  * Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  *
  * @return {boolean} Whether all DOM nodes are present or not
  */

	_createClass(CreditCard, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el) {
				hasVerified = false;
			}
			return hasVerified;
		}

		/**
   * Initialise the class
   *
   * @return {void}
   */

	}, {
		key: 'init',
		value: function init() {
			var _this = this;

			if (!this.el.parentNode.classList.contains('dna-input-credit-card-wrap')) {
				this.wrapEl();
			}
			this.decorateEl();

			this[addValidClasses] = function () {
				_this.wrapper.classList.add('dna-input-credit-card-wrap-valid');
			};

			this[addValidPendingClasses] = function () {
				_this.wrapper.classList.add('dna-input-credit-card-wrap-valid-pending');
			};

			this[addErrorClasses] = function () {
				_this.wrapper.classList.add('dna-input-credit-card-wrap-is-error');
				_this.el.classList.add('dna-input-error');
			};

			this[removeClasses] = function () {
				_this.wrapper.classList.remove('dna-input-credit-card-wrap-valid');
				_this.wrapper.classList.remove('dna-input-credit-card-wrap-valid-pending');
				_this.wrapper.classList.remove('dna-input-credit-card-wrap-is-error');
				_this.el.classList.remove('dna-input-error');
			};

			this[handler] = function (e) {
				if (_this.keyupTimer) {
					clearTimeout(_this.keyupTimer);
				}

				_this.keyupTimer = setTimeout(function () {
					var value = e.target.value;
					var valid = true;

					if (/^[a-z0-36-9]|[a-z]/i.test(value)) {
						valid = false;
						return _this[addErrorClasses]();
					}

					// Skip validation if incomplete Visa/MasterCard or empty value
					if (valid) {
						_this[removeClasses]();
						if (!value) {
							return true;
						}
						if (value.charAt(0) === '4' && value.length < 13 || value.charAt(0) === '5' && value.length < 16) {
							return _this[addValidPendingClasses]();
						}
					}

					valid = _this.validate(value);

					if (valid) {
						_this[removeClasses]();
						_this[addValidClasses]();
					} else {
						_this[removeClasses]();
						_this[addValidPendingClasses]();
					}
				}, 100);
			};

			this.bindEvents();
		}

		/**
   * Validate given string against internal regex
   *
   * @param {string} cc
   * @return {boolean}
   */

	}, {
		key: 'validate',
		value: function validate(cc) {
			return this.regex.test(cc);
		}

		/**
   * Wrap this.el in div and set maxlength
   *
   * @return {void}
   */

	}, {
		key: 'wrapEl',
		value: function wrapEl() {
			var div = document.createElement('div');
			div.classList.add('dna-input-credit-card-wrap');
			this.el.parentNode.insertBefore(div, this.el);
			div.appendChild(this.el);
			this.wrapper = div;
		}

		/**
      * Decorate elemet with maxlength attribute
      *
      * @return {void}
      */

	}, {
		key: 'decorateEl',
		value: function decorateEl() {
			this.el.setAttribute('maxlength', 16);
		}

		/**
   * Bind event handlers
   *
   * @return {void}
   */

	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			this.el.addEventListener('keyup', this[handler], false);
		}

		/**
   * Unbind event handlers
   *
   * @return {void}
   */

	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			this.el.removeEventListener('keyup', this[handler], false);
		}
	}]);

	return CreditCard;
}();

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/input/input.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _password = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input/password.js");

Object.defineProperty(exports, 'Password', {
  enumerable: true,
  get: function get() {
    return _password.Password;
  }
});

var _creditcard = __webpack_require__("./node_modules/@justgiving/dna-form/lib/input/creditcard.js");

Object.defineProperty(exports, 'CreditCard', {
  enumerable: true,
  get: function get() {
    return _creditcard.CreditCard;
  }
});

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/input/password.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Password = undefined;

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var handler = Symbol();

var Password = exports.Password = function () {
	function Password() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, Password);

		this.el = options.el;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM()) {
			_eventemitter.emitter.emit('dna.Input.Password.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.Input.Password.didInit', {
			emitter: this
		});
	}

	/**
  * Verify the required DOM nodes are present
  * Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  *
  * @return {boolean} Whether all DOM nodes are present or not
  */

	_createClass(Password, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el) {
				hasVerified = false;
			}
			return hasVerified;
		}

		/**
   * Initialise the class
   *
   * @return {void}
   */

	}, {
		key: 'init',
		value: function init() {
			if (!this.el.parentNode.classList.contains('dna-input-password-wrap')) {
				this.wrapEl();
			} else {
				this.button = this.el.parentNode.querySelector('.dna-input-password-button');
			}

			this[handler] = function (e) {
				e.preventDefault();
				e.target.textContent = this.el.type === 'password' ? 'Hide' : 'Show';
				if (this.el.type === 'password') {
					this.el.type = 'text';
				} else {
					this.el.type = 'password';
				}
			}.bind(this);

			this.bindEvents();
		}

		/**
   * Wrap this.el in div and add button
   *
   * @return {void}
   */

	}, {
		key: 'wrapEl',
		value: function wrapEl() {
			var div = document.createElement('div');
			var btn = document.createElement('button');
			var btnText = document.createTextNode('Show');

			div.classList.add('dna-input-password-wrap');
			btn.classList.add('dna-input-password-button');
			btn.type = 'button';

			btn.appendChild(btnText);
			this.el.parentNode.insertBefore(div, this.el);
			div.appendChild(this.el);
			div.appendChild(btn);
			this.button = btn;
		}

		/**
   * Bind event handlers
   *
   * @return {void}
   */

	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			this.button.addEventListener('click', this[handler], false);
		}

		/**
   * Unbind event handlers
   *
   * @return {void}
   */

	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			this.button.removeEventListener('click', this[handler], false);
		}
	}]);

	return Password;
}();

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/lib/select/select.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = __webpack_require__("./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var keys = {
	TAB: 9,
	UP_ARROW: 38,
	DOWN_ARROW: 40,
	SPACE: 32,
	ENTER: 13
};
var privateData = {};

/**
 * Class representing a dna select
 * @classdesc Constructor for a dna select
 * @param {object} options.el. Class instance's parent element
 * @param {number} options.width. Constrain element to given width, otherwise set to largest option
 * @param {number} options.optionsWidth. Set a default width for options list
 * @param {string} options.optionsPosition. Give 'left' or 'right' for options list to clamp to
 * @param {bool} options.valueAsSelected. If true, have selectedValue be equal to value, not option text
 */

var Select = function () {
	function Select() {
		var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		_classCallCheck(this, Select);

		this.el = options.el;
		this.width = options.width;
		this.optionsWidth = options.optionsWidth;
		this.optionsPosition = options.optionsPosition || 'right';
		this.valueAsSelected = options.valueAsSelected || false;

		// Cancel instantiation if DOM not as expected
		if (!this.verifyDOM() || document.querySelector('html').className.indexOf('ie8') > -1) {
			_eventemitter.emitter.emit('dna.Select.didCancelInit', {
				emitter: this
			});
			return {};
		}

		this.init();

		// Everything inited as expected
		_eventemitter.emitter.emit('dna.Select.didInit', {
			emitter: this
		});

		return this;
	}

	/**
  * Verify the required DOM nodes are present
  * @description Check that the object instance's parent element, and any necessary child nodes, are present in the DOM
  * @returns {Boolean} Whether all DOM nodes are present or not
  */

	_createClass(Select, [{
		key: 'verifyDOM',
		value: function verifyDOM() {
			var hasVerified = true;
			if (!this.el || this.el.tagName.toLowerCase() !== 'select') {
				hasVerified = false;
			}
			return hasVerified;
		}

		/**
   * Initialise the class
   * @description
   */

	}, {
		key: 'init',
		value: function init() {
			this.wrapEl();
			this.setWidth();

			privateData.clickHandler = function (e) {
				if (e.target.closest('.dna-select') !== null && e.target.closest('.dna-select') === this.wrapper || e.target.matches('.dna-select') && e.target === this.wrapper) {
					if (this.wrapper.matches('.dna-select-open') && e.target.matches('.dna-select-option')) {
						this.chooseOption(e.target);
						this.wrapper.focus();
					}

					this.wrapper.classList.toggle('dna-select-open');
				} else {
					this.wrapper.classList.remove('dna-select-open');
				}
			}.bind(this);

			privateData.keyboardHandler = function (e) {
				if (e.keyCode !== keys.TAB) {
					e.preventDefault();
				}

				// Space and enter toggle list
				if (e.keyCode === keys.SPACE || e.keyCode === keys.ENTER) {
					this.wrapper.classList.toggle('dna-select-open');

					if (e.target.matches('.dna-select-option')) {
						this.wrapper.focus();
					} else {
						this.list.querySelector('.dna-select-option-selected').focus();
					}
				}

				// Down arrow focuses and selects next available option
				if (e.keyCode === keys.DOWN_ARROW) {
					var nextSibling = this.list.querySelector('.dna-select-option-selected').nextSibling || this.list.children[this.list.children.length - 1];
					nextSibling.focus();
					this.chooseOption(nextSibling);
				}

				// Up arrow focuses and selects previous available option
				if (e.keyCode === keys.UP_ARROW) {
					var previousSibling = this.list.querySelector('.dna-select-option-selected').previousSibling || this.list.children[0];
					previousSibling.focus();
					this.chooseOption(previousSibling);
				}
			}.bind(this);

			privateData.changeHandler = function (e) {
				this.selectedValue.textContent = this.valueAsSelected ? e.target.value : e.target.children[e.target.selectedIndex].textContent;
			}.bind(this);

			this.bindEvents();
		}
	}, {
		key: 'wrapEl',
		value: function wrapEl() {
			var wrapper = document.createElement('div');
			var selectedValue = document.createElement('span');
			var button = document.createElement('span');
			var list = document.createElement('ul');
			var selectedValueText = this.valueAsSelected ? document.createTextNode(this.el.value) : document.createTextNode(this.el.children[this.el.selectedIndex].textContent);

			// Add wrapper classes
			wrapper.classList.add('dna-select');
			button.classList.add('dna-select-arrow');
			selectedValue.classList.add('dna-select-value');
			list.classList.add('dna-select-options');

			// Add options position classes
			if (this.optionsPosition === 'right' || this.optionsPosition !== 'left') {
				list.classList.add('dna-select-options-right');
			}

			if (this.optionsPosition === 'left') {
				list.classList.add('dna-select-options-left');
			}

			// Add size variant classes
			if (this.el.classList.contains('dna-select-medium')) {
				wrapper.classList.add('dna-select-medium');
				button.classList.add('dna-select-arrow-medium');
				list.classList.add('dna-select-options-medium');
			}

			if (this.el.classList.contains('dna-select-large')) {
				wrapper.classList.add('dna-select-large');
				button.classList.add('dna-select-arrow-large');
				list.classList.add('dna-select-options-large');
			}

			if (this.el.classList.contains('dna-select-full-width')) {
				wrapper.classList.add('dna-select-full-width');
			}

			wrapper.setAttribute('tabindex', 0);

			[].slice.call(this.el.querySelectorAll('option')).forEach(function (option) {
				var item = document.createElement('li');
				item.setAttribute('data-value', option.value);
				item.setAttribute('tabindex', 1);
				item.textContent = option.textContent;
				item.classList.add('dna-select-option');
				if (option.selected) {
					item.classList.add('dna-select-option-selected');
				}
				list.appendChild(item);
			});

			selectedValue.appendChild(selectedValueText);

			this.el.parentNode.insertBefore(wrapper, this.el);
			wrapper.appendChild(button);
			wrapper.appendChild(selectedValue);
			wrapper.appendChild(list);
			wrapper.appendChild(this.el);

			this.selectedValue = selectedValue;
			this.list = list;
			this.wrapper = wrapper;
		}
	}, {
		key: 'chooseOption',
		value: function chooseOption(item) {
			this.selectedValue.textContent = this.valueAsSelected ? item.getAttribute('data-value') : item.textContent;
			this.el.value = item.getAttribute('data-value');
			[].slice.call(this.list.children).forEach(function (option) {
				return option.classList.remove('dna-select-option-selected');
			});
			item.classList.add('dna-select-option-selected');
			var event = document.createEvent('HTMLEvents');
			event.initEvent('change', true, true);
			this.el.dispatchEvent(event);
		}
	}, {
		key: 'setWidth',
		value: function setWidth() {
			var wrapperWidth = this.width || 0;
			var optionsWidth = this.optionsWidth || 0;

			if (wrapperWidth === 0) {
				var clone = this.list.cloneNode(true);
				clone.style.top = '-999em';
				clone.style.width = 'auto';
				clone.style.display = 'block';
				document.body.appendChild(clone);
				wrapperWidth = clone.offsetWidth;
				document.body.removeChild(clone);
			}

			this.wrapper.style.width = wrapperWidth + 'px';

			if (optionsWidth !== 0) {
				this.list.style.width = optionsWidth + 'px';
			}
		}
	}, {
		key: 'bindEvents',
		value: function bindEvents() {
			document.addEventListener('click', privateData.clickHandler, false);
			this.wrapper.addEventListener('keydown', privateData.keyboardHandler, false);
			this.el.addEventListener('change', privateData.changeHandler, false);
		}
	}, {
		key: 'unbindEvents',
		value: function unbindEvents() {
			document.removeEventListener('click', privateData.clickHandler, false);
			this.wrapper.removeEventListener('keydown', privateData.keyboardHandler, false);
			this.el.removeEventListener('change', privateData.changeHandler, false);
		}
	}]);

	return Select;
}();

module.exports = Select;

/***/ }),

/***/ "./node_modules/@justgiving/dna-form/node_modules/@justgiving/dna-core/components/eventemitter/index.js":
/***/ (function(module, exports, __webpack_require__) {

var EventEmitter = __webpack_require__("./node_modules/eventemitter3/index.js");

exports.emitter = new EventEmitter();


/***/ }),

/***/ "./node_modules/@justgiving/justgiving-bundle-head-js/dist/head.min.js":
/***/ (function(module, exports) {

!function(e,n,t){function s(e,n){return typeof e===n}function o(){var e,n,t,o,r,i,a;for(var f in y)if(y.hasOwnProperty(f)){if(e=[],n=y[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=s(n.fn,"function")?n.fn():n.fn,r=0;r<e.length;r++)i=e[r],a=i.split("."),1===a.length?w[a[0]]=o:(!w[a[0]]||w[a[0]]instanceof Boolean||(w[a[0]]=new Boolean(w[a[0]])),w[a[0]][a[1]]=o),C.push((o?"":"no-")+a.join("-"))}}function r(e){var n=S.className,t=w._config.classPrefix||"";if(b&&(n=n.baseVal),w._config.enableJSClass){var s=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(s,"$1"+t+"js$2")}w._config.enableClasses&&(n+=" "+t+e.join(" "+t),b?S.className.baseVal=n:S.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):b?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function a(){var e=n.body;return e||(e=i(b?"svg":"body"),e.fake=!0),e}function f(e,t,s,o){var r,f,l,u,d="modernizr",c=i("div"),p=a();if(parseInt(s,10))for(;s--;)l=i("div"),l.id=o?o[s]:d+(s+1),c.appendChild(l);return r=i("style"),r.type="text/css",r.id="s"+d,(p.fake?p:c).appendChild(r),p.appendChild(c),r.styleSheet?r.styleSheet.cssText=e:r.appendChild(n.createTextNode(e)),c.id=d,p.fake&&(p.style.background="",p.style.overflow="hidden",u=S.style.overflow,S.style.overflow="hidden",S.appendChild(p)),f=t(c,e),p.fake?(p.parentNode.removeChild(p),S.style.overflow=u,S.offsetHeight):c.parentNode.removeChild(c),!!f}function l(e,n){return!!~(""+e).indexOf(n)}function u(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(n,s){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(u(n[o]),s))return!0;return!1}if("CSSSupportsRule"in e){for(var r=[];o--;)r.push("("+u(n[o])+":"+s+")");return r=r.join(" or "),f("@supports ("+r+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return t}function c(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function p(e,n,o,r){function a(){u&&(delete z.style,delete z.modElem)}if(r=s(r,"undefined")?!1:r,!s(o,"undefined")){var f=d(e,o);if(!s(f,"undefined"))return f}for(var u,p,m,v,h,g=["modernizr","tspan"];!z.style;)u=!0,z.modElem=i(g.shift()),z.style=z.modElem.style;for(m=e.length,p=0;m>p;p++)if(v=e[p],h=z.style[v],l(v,"-")&&(v=c(v)),z.style[v]!==t){if(r||s(o,"undefined"))return a(),"pfx"==n?v:!0;try{z.style[v]=o}catch(y){}if(z.style[v]!=h)return a(),"pfx"==n?v:!0}return a(),!1}function m(e,n){return function(){return e.apply(n,arguments)}}function v(e,n,t){var o;for(var r in e)if(e[r]in n)return t===!1?e[r]:(o=n[e[r]],s(o,"function")?m(o,t||n):o);return!1}function h(e,n,t,o,r){var i=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+E.join(i+" ")+i).split(" ");return s(n,"string")||s(n,"undefined")?p(a,n,o,r):(a=(e+" "+P.join(i+" ")+i).split(" "),v(a,n,t))}function g(e,n,s){return h(e,t,t,n,s)}var y=[],x={_version:"3.2.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){y.push({name:e,fn:n,options:t})},addAsyncTest:function(e){y.push({name:null,fn:e})}},w=function(){};w.prototype=x,w=new w;var C=[],S=n.documentElement,b="svg"===S.nodeName.toLowerCase(),T=x._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):[];x._prefixes=T;var _=x.testStyles=f;w.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var s=["@media (",T.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");_(s,function(e){t=9===e.offsetTop})}return t});var j="Moz O ms Webkit",E=x._config.usePrefixes?j.split(" "):[];x._cssomPrefixes=E;var N={elem:i("modernizr")};w._q.push(function(){delete N.elem});var z={style:N.elem.style};w._q.unshift(function(){delete z.style});var P=x._config.usePrefixes?j.toLowerCase().split(" "):[];x._domPrefixes=P,x.testAllProps=h,x.testAllProps=g,w.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&g("transform","scale(1)",!0)});var k="CSS"in e&&"supports"in e.CSS,A="supportsCSS"in e;w.addTest("supports",k||A),w.addTest("csstransforms3d",function(){var e=!!g("perspective","1px",!0),n=w._config.usePrefixes;if(e&&(!n||"webkitPerspective"in S.style)){var t,s="#modernizr{width:0;height:0}";w.supports?t="@supports (perspective: 1px)":(t="@media (transform-3d)",n&&(t+=",(-webkit-transform-3d)")),t+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",_(s+t,function(n){e=7===n.offsetWidth&&18===n.offsetHeight})}return e}),w.addTest("csstransitions",g("transition","all",!0)),w.addTest("cssanimations",g("animationName","a",!0)),w.addTest("flexbox",g("flexBasis","1px",!0)),w.addTest("flexboxlegacy",g("boxDirection","reverse",!0)),w.addTest("flexboxtweener",g("flexAlign","end",!0)),w.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect),o(),r(C),delete x.addTest,delete x.addAsyncTest;for(var q=0;q<w._q.length;q++)w._q[q]();e.Modernizr=w}(window,document),function(e,n,t){var s=n.documentElement.className;s.indexOf("no-js")>-1?n.documentElement.className=s.split("no-js").join("js"):n.documentElement.className+=" js"}(window,document);
//# sourceMappingURL=head.min.js.map


/***/ }),

/***/ "./node_modules/eventemitter3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "./src/components/CategoryField/CategoryField.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryFieldFormik; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Select__ = __webpack_require__("./src/components/Select/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");



var CategoryField = function (_a) {
    var categories = _a.categories, input = _a.input, labelClassName = _a.labelClassName, onSelectionChanged = _a.onSelectionChanged;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "category-field", className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group col-xs-12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: labelClassName + " jg-form-label", htmlFor: "category" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "CategoryField.label", defaultMessage: "Category" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Select__["a" /* default */], { items: categories.map(function (category) { return ({
                    value: category.id.toString(),
                    label: category.name,
                    isSelected: category.id === input.value,
                }); }), placeholder: "Choose a category", onChange: function (selectedCategory) {
                    input.onChange(selectedCategory.value);
                    if (onSelectionChanged) {
                        onSelectionChanged({ categoryName: selectedCategory.label });
                    }
                } }))));
};
var CategoryFieldFormik = function (_a) {
    var categories = _a.categories, input = _a.input, labelClassName = _a.labelClassName, onSelectionChanged = _a.onSelectionChanged;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "category-field", className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-form-group col-xs-12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: labelClassName + " jg-form-label", htmlFor: "category" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], { id: "CategoryField.label", defaultMessage: "Category" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Select__["a" /* default */], { items: categories.map(function (category) { return ({
                    value: category.id.toString(),
                    label: category.name,
                    isSelected: category.id === input.value,
                }); }), placeholder: "Choose a category", onChange: function (selectedCategory) {
                    input.onChange(selectedCategory.value);
                    if (onSelectionChanged) {
                        onSelectionChanged({ categoryName: selectedCategory.label });
                    }
                } }))));
};
/* harmony default export */ __webpack_exports__["b"] = (CategoryField);



/***/ }),

/***/ "./src/components/CategoryField/index.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryField__ = __webpack_require__("./src/components/CategoryField/CategoryField.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CategoryField__["b"]; });



/***/ }),

/***/ "./src/components/CharityEndorsed/CreateCharityEndorsedPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_CreateEndorsedPage__ = __webpack_require__("./src/components/CharityEndorsed/CreateEndorsedPage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_CharityEndorsed_CreateCommittedPage__ = __webpack_require__("./src/components/CharityEndorsed/CreateCommittedPage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_ab__ = __webpack_require__("./src/helpers/api/ab.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var CharityEndorsedCommitment;
(function (CharityEndorsedCommitment) {
    CharityEndorsedCommitment["Endorsement"] = "A";
    CharityEndorsedCommitment["Commitment"] = "B";
})(CharityEndorsedCommitment || (CharityEndorsedCommitment = {}));
var CreateCharityEndorsedPage = /** @class */ (function (_super) {
    __extends(CreateCharityEndorsedPage, _super);
    function CreateCharityEndorsedPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            displayCharityOptions: false,
            abOption: '',
        };
        return _this;
    }
    CreateCharityEndorsedPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var abOption;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_ab__["a" /* enrol */])('cf_owner_charity_commitment_level')];
                    case 1:
                        abOption = _a.sent();
                        this.props.changeEndorsementAcceptance(true, abOption === CharityEndorsedCommitment.Endorsement
                            ? 'Endorsement'
                            : 'Commitment');
                        this.setState({
                            displayCharityOptions: true,
                            abOption: abOption,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateCharityEndorsedPage.prototype.render = function () {
        var _a = this.props, changeEndorsementAcceptance = _a.changeEndorsementAcceptance, charity = _a.charity, isEndorsementAccepted = _a.isEndorsementAccepted;
        var _b = this.state, displayCharityOptions = _b.displayCharityOptions, abOption = _b.abOption;
        if (!displayCharityOptions) {
            return null;
        }
        return abOption === CharityEndorsedCommitment.Endorsement ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_CharityEndorsed_CreateEndorsedPage__["a" /* default */], { charity: charity, isEndorsementAccepted: isEndorsementAccepted, onChange: function (e) {
                return changeEndorsementAcceptance(e.target.checked, 'Endorsement');
            } })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_CharityEndorsed_CreateCommittedPage__["a" /* default */], { charity: charity, isEndorsementAccepted: isEndorsementAccepted, onChange: function (e) {
                return changeEndorsementAcceptance(e.target.checked, 'Commitment');
            } }));
    };
    return CreateCharityEndorsedPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (CreateCharityEndorsedPage);


/***/ }),

/***/ "./src/components/CharityEndorsed/CreateCommittedPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EndorsingCharityLogo__ = __webpack_require__("./src/components/CharityEndorsed/EndorsingCharityLogo.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CharityEndorsed_scss__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CharityEndorsed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CharityEndorsed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__ = __webpack_require__("./node_modules/@justgiving/responsive/es/index.js");





var CreateCommittedPage = function (_a) {
    var charity = _a.charity, isEndorsementAccepted = _a.isEndorsementAccepted, onChange = _a.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset", { className: "jg-form-group jg-space-mtmd jg-space-mblg", key: "charity-endorsed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "checkbox", id: "checkbox-charity-endorsed", name: "checkbox-charity-endorsed", onChange: onChange, className: "jg-checkbox", defaultChecked: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { htmlFor: "checkbox-charity-endorsed" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--regular" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "CreateCommittedPage.iWantToBeEndorsed", defaultMessage: "I'd like my page to be associated with {charityName}, and will make a contribution to the charity ", values: {
                            charityName: charity.name,
                        } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_3__CharityEndorsed_scss___default.a['charity-info'] + " jg-display-flex " + (isEndorsementAccepted ? '' : __WEBPACK_IMPORTED_MODULE_3__CharityEndorsed_scss___default.a.opacity) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__["c" /* LessThanMedium */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md", smallIcon: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__["d" /* Medium */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--light jg-text" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedPage.yourPageWillBeAssociated", defaultMessage: "Your page will be associated with {charityName}. Their logo will appear on your page, and you can make your contribution to them at any time whilst you\u2019re crowdfunding to support the great work they do.", values: { charityName: charity.name } })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (CreateCommittedPage);


/***/ }),

/***/ "./src/components/CharityEndorsed/CreateEndorsedPage.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CharityEndorsed_scss__ = __webpack_require__("./src/components/CharityEndorsed/CharityEndorsed.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CharityEndorsed_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CharityEndorsed_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_CharityEndorsed_EndorsingCharityLogo__ = __webpack_require__("./src/components/CharityEndorsed/EndorsingCharityLogo.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__ = __webpack_require__("./node_modules/@justgiving/responsive/es/index.js");





var CreateEndorsedPage = function (_a) {
    var charity = _a.charity, isEndorsementAccepted = _a.isEndorsementAccepted, onChange = _a.onChange;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset", { className: "jg-form-group jg-space-mtmd jg-space-mblg", key: "charity-endorsed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "checkbox", id: "checkbox-charity-endorsed", name: "checkbox-charity-endorsed", onChange: onChange, className: "jg-checkbox", defaultChecked: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { htmlFor: "checkbox-charity-endorsed" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-text--regular" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "CreateEndorsedPage.iWantToBeEndorsed", defaultMessage: "I'd like my page to be associated with {charityName}", values: {
                            charityName: charity.name,
                        } })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_2__CharityEndorsed_scss___default.a['charity-info'] + " jg-display-flex " + (isEndorsementAccepted ? '' : __WEBPACK_IMPORTED_MODULE_2__CharityEndorsed_scss___default.a.opacity) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__["c" /* LessThanMedium */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_CharityEndorsed_EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md", smallIcon: true })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_responsive__["d" /* Medium */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_CharityEndorsed_EndorsingCharityLogo__["a" /* default */], { displayTick: true, charityLogo: charity.logo, className: "jg-space-mrms@md jg-space-mbsm jg-space-mbn@md" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-text--light jg-text" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], { id: "CharityEndorsedPage.yourPageWillBeAssociated", defaultMessage: "Your page will be associated with {charityName}. Their logo will appear on your page, and if you wish to support the great work they do, you can make a contribution to them at any time whilst you\u2019re crowdfunding.", values: { charityName: charity.name } })))))));
};
/* harmony default export */ __webpack_exports__["a"] = (CreateEndorsedPage);


/***/ }),

/***/ "./src/components/CreateForm/AmountField.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dna__ = __webpack_require__("./src/components/dna/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_forms__ = __webpack_require__("./src/helpers/forms.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var AmountField = function (_a) {
    var targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, styles = _a.styles, prefix = _a.prefix;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-input-select-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-form-field" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.label), htmlFor: "target" }, "We\u02BCre raising"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__dna__["a" /* PrefixedInput */], __assign({}, targetAmount.input, { id: "target", type: "number", min: "2", max: "9999999", prefix: prefix || '£', className: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_forms__["b" /* inputDNAClassNames */])({
                    touched: targetAmount.meta.touched ? true : false,
                    error: targetAmount.meta.error,
                }, styles.target, 'dna-input', 'dna-input-text') })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* ValidationResult */], { touched: targetAmount.meta.touched, error: targetAmount.meta.error }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: styles.note }, "You can edit your target later."),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: styles.note }, Object(__WEBPACK_IMPORTED_MODULE_5_src_helpers_currencyMap__["f" /* getCurrencyMessage */])(targetCurrency.input.value)))));
};
/* harmony default export */ __webpack_exports__["a"] = (AmountField);


/***/ }),

/***/ "./src/components/CreateForm/AmountWithCurrencyField.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__ = __webpack_require__("./node_modules/@justgiving/dna-form/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dna__ = __webpack_require__("./src/components/dna/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_forms__ = __webpack_require__("./src/helpers/forms.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};







var AmountWithCurrencyField = /** @class */ (function (_super) {
    __extends(AmountWithCurrencyField, _super);
    function AmountWithCurrencyField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmountWithCurrencyField.prototype.componentDidMount = function () {
        this.inputSelectGroup = new __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__["InputSelectGroup"]({
            el: this.formField,
            selectWidth: 100,
            selectOptionsWidth: this.formField.offsetWidth,
            bindSelectValueToPrefix: true,
            selectValueAsSelected: true,
            bindingTransform: function (value) { return __WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["b" /* currencyMap */][value]; },
        });
    };
    AmountWithCurrencyField.prototype.componentWillUnmount = function () {
        delete this.inputSelectGroup;
    };
    AmountWithCurrencyField.prototype.getCurrencyOptions = function () {
        var currencyOptions = {};
        Object.values(this.props.supportedCurrencies).forEach(function (x) {
            currencyOptions[x.currency.code] = x.currency.name;
        });
        return currencyOptions;
    };
    AmountWithCurrencyField.prototype.render = function () {
        var _this = this;
        var _a = this.props, targetAmount = _a.targetAmount, targetCurrency = _a.targetCurrency, styles = _a.styles;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-input-select-group", ref: function (c) {
                _this.formField = c;
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-form-field" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-label', styles.label), htmlFor: "donation-amount" }, "We\u02BCre raising"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styles['target-currency'] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styles['target-wrapper'] },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", __assign({}, targetAmount.input, { id: "target", className: Object(__WEBPACK_IMPORTED_MODULE_4__helpers_forms__["b" /* inputDNAClassNames */])({
                                touched: targetAmount.meta.touched ? true : false,
                                error: targetAmount.meta.error,
                            }, 'dna-input', 'dna-input-text', 'js-dna-input-prefix', styles.target), "data-dna-input-prefix": "\u00A3", type: "number" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__dna__["b" /* Select */], __assign({}, targetCurrency.input, { id: "currency", className: "js-dna-select", fieldClass: styles.currency, disableMobileNative: true, isLabelHidden: true, value: targetCurrency.input.value, handleChange: function (value) { return targetCurrency.input.onChange(value); }, options: this.getCurrencyOptions() }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers_validation__["a" /* ValidationResult */], { touched: targetAmount.meta.touched, error: targetAmount.meta.error }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: styles.note }, "You can edit your target later."),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: styles.note }, Object(__WEBPACK_IMPORTED_MODULE_6_src_helpers_currencyMap__["f" /* getCurrencyMessage */])(targetCurrency.input.value)))));
    };
    return AmountWithCurrencyField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (AmountWithCurrencyField);


/***/ }),

/***/ "./src/components/CreateForm/CreateForm.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"gh0Do","header":"Yh1gk","title":"HhVrH","subtitle":"CXA_z","form":"Pc4Lw","label":"_3MQVG","note":"_3I9ki","target-currency":"_1WCLC","target-wrapper":"_1rf-V","target":"_1GfAB","currency":"DvQap","category":"_3lIdG","placeholder":"_2zqcA","footer":"_2dYh_","action":"_1E6yR","pitch-wrapper":"_3a2uv","character-count":"FeGkN","invalid":"ET1v1","pitch":"_3-cZH"};

/***/ }),

/***/ "./src/components/CreateForm/CreateForm.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__("./node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__("./node_modules/react-i18next/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_LoadingButton___ = __webpack_require__("./src/components/LoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_CategoryField__ = __webpack_require__("./src/components/CategoryField/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss__ = __webpack_require__("./src/components/CreateForm/CreateForm.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CreateForm_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__createFormValidator__ = __webpack_require__("./src/components/CreateForm/createFormValidator.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PitchField__ = __webpack_require__("./src/components/CreateForm/PitchField.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AmountField__ = __webpack_require__("./src/components/CreateForm/AmountField.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AmountWithCurrencyField__ = __webpack_require__("./src/components/CreateForm/AmountWithCurrencyField.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_CharityEndorsed_CreateCharityEndorsedPage__ = __webpack_require__("./src/components/CharityEndorsed/CreateCharityEndorsedPage.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_MarkSuccess_MarkSuccess__ = __webpack_require__("./src/components/MarkSuccess/MarkSuccess.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_constants_experiments__ = __webpack_require__("./src/constants/experiments.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var CreateForm = /** @class */ (function (_super) {
    __extends(CreateForm, _super);
    function CreateForm(props) {
        var _this = _super.call(this, props) || this;
        _this.getErrorMessage = function (reason) {
            if (reason === 'rate_limit_exceeded') {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Alert__["a" /* default */], { id: "creation-alert", type: "red", displayType: "inline", persistent: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */], { id: "CreateForm.pageCreationLimitHit", defaultMessage: "We\u2019re sorry, you have reached the limit of new pages per day. For help creating another page please contact our {supportLink}.", values: {
                                supportLink: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://help.justgiving.com/hc/en-us/categories/201602465-Crowdfunding" },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */], { id: "CreateForm.pageCreationLimitHit.supportLink", defaultMessage: "customer support" }))),
                            } }))));
            }
            if (reason !== null) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Alert__["a" /* default */], { id: "create-alert", type: "red", displayType: "inline", persistent: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */], { id: "CreateForm.submissionErrorText", defaultMessage: "An error has occurred, please try again" }))));
            }
            return null;
        };
        _this.changeEndorsementAcceptance = function (checked, commitmentType) {
            var _a = _this.props, dispatch = _a.dispatch, charity = _a.charity;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["d" /* change */])('create', 'charityId', checked ? charity.id : null));
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["d" /* change */])('create', 'commitmentType', commitmentType));
            _this.setState({
                isEndorsementAccepted: checked,
            });
        };
        if (true) {
            __webpack_require__("./node_modules/@justgiving/justgiving-bundle-head-js/dist/head.min.js");
        }
        _this.state = {
            isEndorsementAccepted: true,
        };
        return _this;
    }
    CreateForm.prototype.render = function () {
        var _a = this.props, charity = _a.charity, submitting = _a.submitting, handleSubmit = _a.handleSubmit, invalid = _a.invalid, pristine = _a.pristine, categories = _a.categories, onCategoryChanged = _a.onCategoryChanged, analyticsClick = _a.analyticsClick, errorReason = _a.errorReason, supportedCurrencies = _a.supportedCurrencies;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.container + " jg-color--nero jg-text--center jg-background--white" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_src_components_MarkSuccess_MarkSuccess__["a" /* MarkSuccess */], { slug: __WEBPACK_IMPORTED_MODULE_14_src_constants_experiments__["a" /* experiments */].b2c_interstitial_option_copy_change, successType: "CrowdfundingPageCreationFlowStarted" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", { className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.header + " jg-background--white jg-text--pull-left jg-space-phsm" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.title + " jg-space-pbxs jg-space-ptmd jg-space-ptlg@md" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */], { id: "CreateForm.startCrowdfunding", defaultMessage: "Let's get started" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.subtitle + " jg-space-mbms jg-space-mbml@md" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */], { i18nKey: "CreateForm.summariseWhatYoureDoing" }, "Tell us what you're raising money for."))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { className: "jg-background--white-smoke jg-bdt jg-bd--solid jg-bd--very-light-grey jg-space-ptms jg-space-ptlg@md jg-space-pbml jg-space-pbxl@md jg-text--pull-left" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", { onSubmit: handleSubmit, className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.form + " jg-space-phsm" },
                    supportedCurrencies.length > 1 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* Fields */], { names: ['targetAmount', 'targetCurrency'], component: __WEBPACK_IMPORTED_MODULE_10__AmountWithCurrencyField__["a" /* default */], styles: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a, supportedCurrencies: supportedCurrencies })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* Fields */], { names: ['targetAmount', 'targetCurrency'], component: __WEBPACK_IMPORTED_MODULE_9__AmountField__["a" /* default */], styles: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { name: "pitchFor", component: __WEBPACK_IMPORTED_MODULE_8__PitchField__["a" /* default */], styles: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a, analyticsClick: analyticsClick, charity: charity }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { name: "categoryId", component: __WEBPACK_IMPORTED_MODULE_5_src_components_CategoryField__["a" /* default */], categories: categories, onSelectionChanged: onCategoryChanged }),
                    charity && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_src_components_CharityEndorsed_CreateCharityEndorsedPage__["a" /* default */], { charity: charity, isEndorsementAccepted: this.state.isEndorsementAccepted, changeEndorsementAcceptance: this.changeEndorsementAcceptance })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer", { className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.footer + " jg-space-mtmd jg-space-mtml@md" },
                        errorReason !== null && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbmd" }, this.getErrorMessage(errorReason))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_LoadingButton___["a" /* default */], { loading: submitting, value: "Continue", disabled: invalid || pristine, className: __WEBPACK_IMPORTED_MODULE_6__CreateForm_scss___default.a.action }))))));
    };
    return CreateForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
var form = Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["h" /* reduxForm */])({
    form: 'create',
    validate: __WEBPACK_IMPORTED_MODULE_7__createFormValidator__["a" /* default */],
})(CreateForm);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["c" /* withI18n */])()(form));


/***/ }),

/***/ "./src/components/CreateForm/PitchField.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_api_create__ = __webpack_require__("./src/helpers/api/create.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Alert__ = __webpack_require__("./src/components/Alert/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__ = __webpack_require__("./src/components/Analytics/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__justgiving_character_count__ = __webpack_require__("./node_modules/@justgiving/character-count/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var PitchField = /** @class */ (function (_super) {
    __extends(PitchField, _super);
    function PitchField(props) {
        var _this = _super.call(this, props) || this;
        _this.closeCharityNameAlert = function () {
            _this.setState({
                showCharityNameAlert: false,
            });
        };
        _this.handleBlur = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var input, value, hasCharityName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = this.props.input;
                        input.onBlur(e);
                        value = e.target.value;
                        if (!(value.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_api_create__["a" /* containsCharityName */])(value)];
                    case 1:
                        hasCharityName = _a.sent();
                        if (hasCharityName) {
                            this.setState({
                                showCharityNameAlert: true,
                            });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.handleFocus = function (e) {
            var input = _this.props.input;
            var showCharityNameAlert = _this.state.showCharityNameAlert;
            input.onFocus(e);
            input.onFocus(e);
            if (showCharityNameAlert) {
                _this.closeCharityNameAlert();
            }
        };
        _this.state = {
            showCharityNameAlert: false,
        };
        return _this;
    }
    PitchField.prototype.render = function () {
        var _this = this;
        var _a = this.props, input = _a.input, styles = _a.styles, _b = _a.meta, touched = _b.touched, error = _b.error, analyticsClick = _a.analyticsClick;
        var showCharityNameAlert = this.state.showCharityNameAlert;
        var analyticsPageSection = 'create > charity notification';
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbms jg-space-mbmd@lg" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.label), htmlFor: "pitchFor" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "PitchField.to", defaultMessage: "to" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__justgiving_character_count__["a" /* default */], { maxLength: 140, value: input.value }, function (_a) {
                var charactersRemaining = _a.charactersRemaining, isValid = _a.isValid;
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styles['pitch-wrapper'] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", __assign({}, input, { autoCapitalize: "none", placeholder: "help fund a new playground", className: styles.pitch, onBlur: _this.handleBlur, onFocus: _this.handleFocus })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "jg-text--small-light " + styles['character-count'] + " " + (!isValid ? 'jg-color--sunset-red' : '') }, charactersRemaining)));
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_validation__["a" /* ValidationResult */], { touched: touched, error: error }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: styles.note },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "PitchField.youCanEditTitleLater", defaultMessage: "You can edit your page title later." })),
            showCharityNameAlert && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "jg-space-mbmd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Alert__["a" /* default */], { id: "charity-name-alert", type: "amber", displayType: "inline", onClose: this.closeCharityNameAlert, analyticsClick: function () {
                        return analyticsClick({
                            event: 'click',
                            eventValue: 'x',
                            pageSection: analyticsPageSection,
                            subtype: 'button',
                        });
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "PitchField.charityNameAlertText", defaultMessage: "It looks like you might be raising money for a registered charity? If so you'll need to {link}.", values: {
                            link: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Analytics__["d" /* Link */], { href: __WEBPACK_IMPORTED_MODULE_2_config__["FUNDRAISING_BASE_URI"], rel: "noreferrer noopener", target: "_blank", analyticsOptions: {
                                    event: 'link click',
                                    eventValue: 'create fundraising page',
                                    pageSection: analyticsPageSection,
                                    subtype: 'hyperlink',
                                } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], { id: "PitchField.charityNameAlertText.fundraisingPageLink", defaultMessage: "create a Fundraising Page" }))),
                        } }))))));
    };
    return PitchField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PitchField);


/***/ }),

/***/ "./src/components/CreateForm/createFormValidator.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__ = __webpack_require__("./src/helpers/validation/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");


var rules = {
    targetAmount: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({ message: 'Please enter the amount you want to raise' }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["g" /* minNumber */])(2, {
            message: function (_, values) {
                return "Sorry, please make sure your target is at least " + __WEBPACK_IMPORTED_MODULE_1_src_helpers_currencyMap__["e" /* default */][values.targetCurrency] + "2";
            },
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["e" /* maxNumber */])(9999999, {
            message: 'Sorry, please make sure your target is achievable',
        }),
    ],
    pitchFor: [
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({ message: 'Please explain how the money will be spent' }),
        Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["d" /* maxLength */])(140, { message: 'This section has a 140 character limit' }),
    ],
    categoryId: [Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["k" /* required */])({ message: 'Please select a category' })],
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_validation__["b" /* createValidator */])(rules));


/***/ }),

/***/ "./src/components/MarkSuccess/MarkSuccess.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_experiments__ = __webpack_require__("./node_modules/@justgiving/experiments/es/src/index.js");


// B2C_052 - b2c_interstitial_option_copy_change
// Can be removed when experiment has ended
var MarkSuccess = function (_a) {
    var slug = _a.slug, successType = _a.successType, keyValues = _a.keyValues;
    var markSuccess = Object(__WEBPACK_IMPORTED_MODULE_1__justgiving_experiments__["e" /* useMarkSuccess */])(slug, successType, keyValues);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        markSuccess();
    }, [markSuccess]);
    return null;
};


/***/ }),

/***/ "./src/components/dna/PrefixedInput.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__ = __webpack_require__("./node_modules/@justgiving/dna-form/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var PrefixedInput = /** @class */ (function (_super) {
    __extends(PrefixedInput, _super);
    function PrefixedInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrefixedInput.prototype.componentDidMount = function () {
        this.prefix = new __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__["InputPrefix"]({
            el: this.input,
        });
    };
    PrefixedInput.prototype.componentWillUnmount = function () {
        delete this.prefix;
    };
    PrefixedInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, prefix = _a.prefix, input = __rest(_a, ["className", "prefix"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", __assign({ ref: function (c) {
                _this.input = c;
            } }, input, { className: className + " js-dna-input-prefix", "data-dna-input-prefix": prefix })));
    };
    return PrefixedInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (PrefixedInput);


/***/ }),

/***/ "./src/components/dna/Select.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Select = function (_a) {
    var id = _a.id, options = _a.options, value = _a.value, label = _a.label, handleChange = _a.handleChange, fieldClass = _a.fieldClass, labelClass = _a.labelClass, selectClass = _a.selectClass, isLabelHidden = _a.isLabelHidden, disableMobileNative = _a.disableMobileNative;
    var fieldClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-form-field', disableMobileNative ? 'disable-mobile-native' : null, fieldClass);
    var labelClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-label', labelClass, {
        'dna-invisible': isLabelHidden,
    });
    var selectClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('js-dna-select', selectClass);
    var optionElements = Object.keys(options).map(function (key, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { value: key, key: index }, options[key])); });
    // hack: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/17946
    var selectProps = { value: value };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: fieldClassName },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: labelClassName, htmlFor: id }, label),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", __assign({ id: id, className: selectClassName }, selectProps, { onChange: handleChange }), optionElements)));
};
/* harmony default export */ __webpack_exports__["a"] = (Select);


/***/ }),

/***/ "./src/components/dna/Textarea.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__ = __webpack_require__("./node_modules/@justgiving/dna-form/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var Textarea = /** @class */ (function (_super) {
    __extends(Textarea, _super);
    function Textarea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resize = function () {
            _this.text.style.height = 'auto';
            _this.text.style.height = _this.text.scrollHeight + 8 + "px";
        };
        _this.delayedResize = function () {
            setTimeout(_this.resize, 0);
        };
        return _this;
    }
    Textarea.prototype.componentDidMount = function () {
        var _a = this.props, hasCharacterCount = _a.hasCharacterCount, maxLength = _a.maxLength, hasCharacterCountTrim = _a.hasCharacterCountTrim;
        if (hasCharacterCount) {
            this.characterCount = new __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__["CharacterCount"]({
                el: this.text,
                maxLength: maxLength,
                trimInput: hasCharacterCountTrim,
            });
        }
    };
    Textarea.prototype.componentDidUpdate = function () {
        if (this.props.value === '' && this.characterCount) {
            this.characterCount = new __WEBPACK_IMPORTED_MODULE_2__justgiving_dna_form__["CharacterCount"]({
                el: this.text,
                maxLength: this.props.maxLength,
                trimInput: this.props.hasCharacterCountTrim,
            });
        }
    };
    Textarea.prototype.renderInput = function () {
        var _this = this;
        var _a = this.props, value = _a.value, hasCharacterCount = _a.hasCharacterCount, inputClass = _a.inputClass, autoResize = _a.autoResize, id = _a.id, maxLength = _a.maxLength;
        var inputClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-textarea', inputClass, {
            'js-dna-character-count': hasCharacterCount,
        });
        if (autoResize) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", { className: inputClassName, ref: function (r) {
                    _this.text = r;
                }, value: value, id: id, maxLength: maxLength, onCut: this.delayedResize, onPaste: this.delayedResize, onDrop: this.delayedResize, onKeyDown: this.delayedResize, onBlur: this.props.handleBlur }));
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", { className: inputClassName, ref: function (r) {
                _this.text = r;
            }, value: value, id: id, maxLength: maxLength, onBlur: this.props.handleBlur }));
    };
    Textarea.prototype.render = function () {
        var _a = this.props, id = _a.id, label = _a.label, fieldClass = _a.fieldClass, labelClass = _a.labelClass, isLabelHidden = _a.isLabelHidden;
        var fieldClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-form-field', fieldClass);
        var labelClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('dna-label', labelClass, {
            'dna-invisible': isLabelHidden,
        });
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: fieldClassName },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: labelClassName, htmlFor: id }, label),
            this.renderInput()));
    };
    return Textarea;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (Textarea);


/***/ }),

/***/ "./src/components/dna/TextareaWithCharacterCount.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__ = __webpack_require__("./node_modules/@justgiving/dna-form/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};



var TextareaWithCharacterCount = /** @class */ (function (_super) {
    __extends(TextareaWithCharacterCount, _super);
    function TextareaWithCharacterCount() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextareaWithCharacterCount.prototype.componentDidMount = function () {
        var _a = this.props, maxLength = _a.maxLength, isTrimmed = _a.isTrimmed;
        this.characterCount = new __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__["CharacterCount"]({
            el: this.text,
            maxLength: maxLength,
            trimInput: isTrimmed,
        });
    };
    TextareaWithCharacterCount.prototype.componentDidUpdate = function () {
        var _a = this.props, maxLength = _a.maxLength, isTrimmed = _a.isTrimmed, value = _a.value;
        if (value === '' && this.characterCount) {
            this.characterCount = new __WEBPACK_IMPORTED_MODULE_1__justgiving_dna_form__["CharacterCount"]({
                el: this.text,
                trimInput: isTrimmed,
                maxLength: maxLength,
            });
        }
    };
    TextareaWithCharacterCount.prototype.componentWillUnmount = function () {
        delete this.characterCount;
    };
    TextareaWithCharacterCount.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, _ = _a.isTrimmed, input = __rest(_a, ["className", "isTrimmed"]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", __assign({}, input, { ref: function (c) {
                _this.text = c;
            }, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'js-dna-character-count') })));
    };
    return TextareaWithCharacterCount;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* unused harmony default export */ var _unused_webpack_default_export = (TextareaWithCharacterCount);


/***/ }),

/***/ "./src/components/dna/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__("./src/components/dna/Select.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Textarea__ = __webpack_require__("./src/components/dna/Textarea.tsx");
/* unused harmony reexport Textarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrefixedInput__ = __webpack_require__("./src/components/dna/PrefixedInput.tsx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__PrefixedInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextareaWithCharacterCount__ = __webpack_require__("./src/components/dna/TextareaWithCharacterCount.tsx");
/* unused harmony reexport TextareaWithCharacterCount */






/***/ }),

/***/ "./src/containers/CreateView.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("./node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__ = __webpack_require__("./src/helpers/renderRoutes.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helpers_asyncConnect__ = __webpack_require__("./src/helpers/asyncConnect.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_logging__ = __webpack_require__("./src/logging.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_CreateForm_CreateForm__ = __webpack_require__("./src/components/CreateForm/CreateForm.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_create__ = __webpack_require__("./src/redux/modules/create.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_redux_modules_categories__ = __webpack_require__("./src/redux/modules/categories.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_redux_modules_ab__ = __webpack_require__("./src/redux/modules/ab.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_redux_modules_analytics__ = __webpack_require__("./src/redux/modules/analytics.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_redux_modules_consents_actions__ = __webpack_require__("./src/redux/modules/consents/actions.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_helpers_api_charity__ = __webpack_require__("./src/helpers/api/charity.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__justgiving_chrome_react__ = __webpack_require__("./node_modules/@justgiving/chrome-react/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__ = __webpack_require__("./node_modules/lodash/sortBy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_helpers_api_iam__ = __webpack_require__("./src/helpers/api/iam.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_helpers_api_self__ = __webpack_require__("./src/helpers/api/self.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GotoLogin__ = __webpack_require__("./src/containers/GotoLogin.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;





















var fetchData = function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
    var loadCategoriesPromise, abUsPreLaunchPromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loadCategoriesPromise = dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_src_redux_modules_categories__["b" /* loadCategories */])());
                abUsPreLaunchPromise = dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_src_redux_modules_ab__["b" /* enrol */])('us_prelaunch'));
                return [4 /*yield*/, Promise.all([loadCategoriesPromise, abUsPreLaunchPromise])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
function getTargetCurrency(countryCode) {
    var preSelectedCurrency = __WEBPACK_IMPORTED_MODULE_12_src_helpers_currencyMap__["a" /* countryToCurrencyMap */][countryCode];
    return (preSelectedCurrency && preSelectedCurrency.code) || 'GBP';
}
function getSupportedCurrencies(countries) {
    return __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default()(countries.map(function (countryCode) { return ({
        country: countryCode,
        currency: __WEBPACK_IMPORTED_MODULE_12_src_helpers_currencyMap__["a" /* countryToCurrencyMap */][countryCode],
    }); }), ['country']);
}
function mapStateToProps(state, ownProps) {
    var initialValues = {
        targetAmount: __WEBPACK_IMPORTED_MODULE_5_config__["DEFAULT_TARGET_VALUE"],
        targetCurrency: getTargetCurrency(state.location.countryCode),
    };
    var submitOnMount = false;
    if (true && ownProps.location.query && ownProps.location.query.data) {
        try {
            initialValues = JSON.parse(atob(ownProps.location.query.data));
            submitOnMount = true;
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_6_src_logging__["a" /* default */].error(err, 'Failed to deserialize create form data from query string.');
        }
    }
    var enabledCountries = state.ab.us_prelaunch === 'B' ? ['GB', 'US'] : ['GB'];
    return {
        initialValues: initialValues,
        submitOnMount: submitOnMount,
        categories: state.categories,
        errorReason: state.create.hasError ? state.create.errorMessage : null,
        supportedCurrencies: getSupportedCurrencies(enabledCountries),
    };
}
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
        createPage: __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_create__["b" /* createPage */],
        getUserConsents: __WEBPACK_IMPORTED_MODULE_13_src_redux_modules_consents_actions__["a" /* getUserConsents */],
        createPageStarted: __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_create__["c" /* createPageStarted */],
        onCategoryChanged: __WEBPACK_IMPORTED_MODULE_8_src_redux_modules_create__["a" /* categoryChanged */],
        analyticsClick: __WEBPACK_IMPORTED_MODULE_11_src_redux_modules_analytics__["a" /* analyticsClick */],
    }, dispatch);
}
var CreateView = /** @class */ (function (_super) {
    __extends(CreateView, _super);
    function CreateView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            charity: null,
        };
        _this.fetchCharityInfo = function (charityId) { return __awaiter(_this, void 0, void 0, function () {
            var charityInfo, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_14_src_helpers_api_charity__["a" /* fetchCharityInfo */])(charityId)];
                    case 1:
                        charityInfo = _b.sent();
                        this.setState({
                            charity: __assign({}, charityInfo),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        this.setState({
                            charity: null,
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleSubmit = function (payload) {
            return _this.props.createPage(payload, _this.state.charity !== null);
        };
        return _this;
    }
    CreateView.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, submitOnMount, initialValues, charityId, user, whiteListedCharity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.toggleChromeStartFundraisingButton(false);
                        _a = this.props, submitOnMount = _a.submitOnMount, initialValues = _a.initialValues;
                        charityId = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(this.props.location.search.substr(1)).charityId;
                        if (true && submitOnMount) {
                            this.handleSubmit(initialValues);
                        }
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_18_src_helpers_api_self__["a" /* get */])()];
                    case 1:
                        user = _b.sent();
                        if (true &&
                            Object(__WEBPACK_IMPORTED_MODULE_17_src_helpers_api_iam__["b" /* isLoggedIn */])() &&
                            Object(__WEBPACK_IMPORTED_MODULE_18_src_helpers_api_self__["b" /* isLoggedIn */])(user) &&
                            (!user.firstName || !user.lastName)) {
                            Object(__WEBPACK_IMPORTED_MODULE_19_src_helpers_url__["c" /* gotoUrl */])(__WEBPACK_IMPORTED_MODULE_5_config__["COMPLETE_PROFILE_URI"] + "?returnUrl=" + encodeURI(window.location.href));
                            return [2 /*return*/];
                        }
                        this.props.createPageStarted();
                        this.props.getUserConsents();
                        whiteListedCharity = __WEBPACK_IMPORTED_MODULE_5_config__["CHARITY_CTA_MAP"][charityId] !== undefined;
                        if (charityId && whiteListedCharity) {
                            this.fetchCharityInfo(charityId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateView.prototype.componentWillUnmount = function () {
        this.toggleChromeStartFundraisingButton(true);
    };
    CreateView.prototype.toggleChromeStartFundraisingButton = function (toggle) {
        // TODO: clean this up once the old Chrome gets removed - all
        // we need to do then is to call refresh on unmount
        if (window.jg && window.jg.chrome) {
            if (window.jg.chrome.toggleStartFundraisingButton) {
                window.jg.chrome.toggleStartFundraisingButton(toggle);
            }
            else if (toggle && window.jg.chrome.refresh) {
                window.jg.chrome.refresh();
            }
        }
    };
    CreateView.prototype.render = function () {
        var _a = this.props, route = _a.route, initialValues = _a.initialValues, categories = _a.categories, onCategoryChanged = _a.onCategoryChanged, analyticsClick = _a.analyticsClick;
        if (true && !Object(__WEBPACK_IMPORTED_MODULE_17_src_helpers_api_iam__["b" /* isLoggedIn */])()) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__GotoLogin__["a" /* GotoLogin */], null);
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__justgiving_chrome_react__["a" /* default */], { headerVariant: "consumer-flow", footerVariant: "slim" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_src_components_CreateForm_CreateForm__["a" /* default */], { onSubmit: this.handleSubmit, initialValues: initialValues, categories: categories, onCategoryChanged: onCategoryChanged, errorReason: this.props.errorReason, analyticsClick: analyticsClick, charity: this.state.charity, supportedCurrencies: this.props.supportedCurrencies }),
            route && Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_renderRoutes__["a" /* default */])(route.routes)));
    };
    return CreateView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_4_src_helpers_asyncConnect__["a" /* default */])(CreateView, {
    mapStateToProps: mapStateToProps,
    mapDispatchToProps: mapDispatchToProps,
    fetchData: fetchData,
    id: 'CREATE_VIEW',
    disableLoadingScreen: true,
}));


/***/ }),

/***/ "./src/containers/GotoLogin.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GotoLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helpers_url__ = __webpack_require__("./src/helpers/url.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GotoLogin = /** @class */ (function (_super) {
    __extends(GotoLogin, _super);
    function GotoLogin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GotoLogin.prototype.componentDidMount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1_src_helpers_url__["c" /* gotoUrl */])(__WEBPACK_IMPORTED_MODULE_2_config__["LOGIN_URI_SSO"] + "?returnUrl=" + encodeURI(window.location.href));
    };
    GotoLogin.prototype.render = function () {
        return null;
    };
    return GotoLogin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ "./src/helpers/api/create.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containsCharityName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__ = __webpack_require__("./src/helpers/api/common.ts");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var taskCount = 0;
function containsCharityName(value) {
    return __awaiter(this, void 0, Promise, function () {
        var currentTaskCount, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    taskCount++;
                    currentTaskCount = taskCount;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_0_src_helpers_api_common__["g" /* post */])("/contentchecks/charitynames", value)];
                case 1:
                    result = _a.sent();
                    if (currentTaskCount === taskCount) {
                        return [2 /*return*/, result.body];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    });
}


/***/ }),

/***/ "./src/helpers/forms.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fieldPropTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = inputDNAClassNames;
/* unused harmony export inputClassNames */
/* unused harmony export focusErrorInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


// based on https://github.com/erikras/redux-form/blob/master/docs/api/Field.md#props
var fieldPropTypes = {
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
    }),
    meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        autofilled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        asyncValidating: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        dirty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
        error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        pristine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        submitFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        touched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        visited: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
        warning: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    }),
    styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
        __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
    ]),
};
// Delete the below when DNA has been fully removed from the project
function inputDNAClassNames(_a, mainClass) {
    var touched = _a.touched, error = _a.error;
    if (mainClass === void 0) { mainClass = 'dna-input'; }
    var additionalClasses = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalClasses[_i - 2] = arguments[_i];
    }
    return __WEBPACK_IMPORTED_MODULE_0_classnames___default.a.apply(void 0, [mainClass,
        { 'dna-input-error': !!touched && !!error }].concat(additionalClasses));
}
function inputClassNames(_a, mainClass) {
    var touched = _a.touched, error = _a.error;
    if (mainClass === void 0) { mainClass = 'jg-form-control'; }
    var additionalClasses = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalClasses[_i - 2] = arguments[_i];
    }
    return __WEBPACK_IMPORTED_MODULE_0_classnames___default.a.apply(void 0, [mainClass,
        { 'jg-form-control--error': !!touched && !!error }].concat(additionalClasses));
}
function focusErrorInput(form) {
    if (true) {
        var input = form.querySelector('.dna-input-error');
        if (input) {
            input.focus();
        }
    }
}


/***/ })

});


// WEBPACK FOOTER //
// create-85ba8d3f97cf74c68a20.js